(() => {
  function getMediaId(target) {
    return String(target || '').split('-').pop();
  }

  function initGallery(gallery) {
    if (gallery.dataset.asVariantGalleryReady === 'true') return;
    gallery.dataset.asVariantGalleryReady = 'true';

    const configEl = document.querySelector('script[id^="AsVariantMediaGallery-"]');
    if (!configEl || typeof gallery.setActiveMedia !== 'function') return;

    const config = JSON.parse(configEl.textContent);
    const mediaIds = config.mediaIds.map(String);
    const startIds = [...new Set(config.variantStartMediaIds.map(String))];

    let startIndexes = startIds
      .map((id) => mediaIds.indexOf(id))
      .filter((index) => index >= 0)
      .sort((a, b) => a - b);

    if (!startIndexes.includes(0)) startIndexes.unshift(0);

    const thumbItems = Array.from(
      gallery.querySelectorAll('[id^="Slider-Thumbnails"] [data-target]')
    );

    function currentMediaIndex() {
      const currentThumb = gallery.querySelector('.thumbnail[aria-current="true"]');
      const item = currentThumb?.closest('[data-target]');
      const mediaId = getMediaId(item?.dataset.target);
      const index = mediaIds.indexOf(mediaId);
      return index >= 0 ? index : 0;
    }

    function rangeForIndex(current) {
      let start = 0;
      let end = mediaIds.length;

      startIndexes.forEach((index, i) => {
        if (index <= current) {
          start = index;
          end = startIndexes[i + 1] ?? mediaIds.length;
        }
      });

      return { start, end };
    }

    function updateThumbVisibilityByIndex(index) {
      const { start, end } = rangeForIndex(index);

      thumbItems.forEach((item) => {
        const thumbIndex = mediaIds.indexOf(getMediaId(item.dataset.target));
        item.hidden = !(thumbIndex >= start && thumbIndex < end);
      });
    }

    function updateThumbVisibility() {
      updateThumbVisibilityByIndex(currentMediaIndex());
    }

  function activateMediaByIndex(index) {
  if (index < 0 || index >= mediaIds.length) return;

  gallery.setActiveMedia(
    `${config.sectionId}-${mediaIds[index]}`,
    false
  );

  setTimeout(() => {
    updateThumbVisibilityByIndex(index);

    const visibleThumbs = thumbItems.filter((item) => !item.hidden);
    const currentThumb = visibleThumbs.find((item) => {
      return mediaIds.indexOf(
        getMediaId(item.dataset.target)
      ) === index;
    });

    currentThumb?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });

  }, 80);
}

    gallery.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest(
          'slider-component[id^="GalleryViewer"] .slider-button'
        );

        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        const current = currentMediaIndex();
        const { start, end } = rangeForIndex(current);

        let next = current;

        if (button.classList.contains('slider-button--next')) {
          next = current + 1 >= end ? start : current + 1;
        }

        if (button.classList.contains('slider-button--prev')) {
          next = current - 1 < start ? end - 1 : current - 1;
        }

        activateMediaByIndex(next);
      },
      true
    );

    document.addEventListener('change', () => {
      setTimeout(() => {
        const current = currentMediaIndex();
        updateThumbVisibilityByIndex(current);
      }, 180);
    });

    document.addEventListener('variant:change', (event) => {
      const mediaId = event.detail?.variant?.featured_media?.id;
      if (!mediaId) return;

      const index = mediaIds.indexOf(String(mediaId));
      if (index >= 0) activateMediaByIndex(index);
    });

    updateThumbVisibility();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();